export const pluginInstruction = `
## Plugins
Plugins, which represent predefined functionality fields, are integral to the richness and functionality of the model. Statements for plugins has to be on one line because of the way the DSL is parsed.

%pluginsSchema%
`;
//# sourceMappingURL=pluginInstruction.js.map